import { AttributeModel } from './AttributeModel';

export class ProductAttributeModel {
    id: string = "";
    idProduct: string = "";
    idAttribute: string = "";
    value: string = "";
    attribute?: AttributeModel = undefined;

    constructor(p?: Partial<ProductAttributeModel>) {
        Object.assign(this, p);

        this._parseAttribute();
    }

    private _parseAttribute():void {
        this.attribute = new AttributeModel(this.attribute);
    }
}
